<template>
  <div class="box5-container">
    <div class="title">设备数量</div>
    <div class="content">
      <div class="progress_box">
        <div class="progress_one">
          <em>设备总数</em>
          <div class="progress_con">
            <el-progress :text-inside="false" :show-text="false" :stroke-width="15" :percentage="100" color="#1de7ff"></el-progress>
          </div>
          <span>{{itemData.lamp}}台</span>
        </div>
        <div class="progress_one">
          <em>在线数量</em>
          <div class="progress_con">
            <el-progress :text-inside="false" :show-text="false" :stroke-width="15" :percentage="return_number(itemData.lamp_online,itemData.lamp)" color="#fff45c"></el-progress>
          </div>
          <span>{{itemData.lamp_online}}台</span>
        </div>
        <div class="progress_one">
          <em>离线数量</em>
          <div class="progress_con">
            <el-progress :text-inside="false" :show-text="false" :stroke-width="15" :percentage="return_number(itemData.lamp_offline,itemData.lamp)" color="#cd3131"></el-progress>
          </div>
          <span>{{itemData.lamp_offline}}台</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Box5",
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total: 0,
          gateway: 0,
          lamp: 0,
          lamp_online: 0,
          gateway_online: 0,
          lamp_offline: 0,
          gateway_offline: 0
        };
      },
    },
  },
  data() {
    return {
    }
  },
  methods: {
    return_number(number,total) {
      number = parseInt(number)
      total = parseInt(total)
      let returnN = 0
      if(number){
        if(number==total){
          returnN = 100
        }else{
          returnN = parseInt(number/total*100)
        }
        
      }
      return returnN
      
    }
  }
};
</script>
<style lang='less'>
.box5-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: #06113c;
  padding:15px 5px 5px 5px;
  box-sizing: border-box;
  .title {
    font-size: 18px;
    line-height: 35px;
    font-weight: normal;
    color: #fff;
    display: block;
    width: 100%;
    height:35px;
    text-align: center;
    background: url(../../assets/images/title_bg.png) center top no-repeat;
    background-size: auto 100%;
  }
  .content {
    position: absolute;
    top: 50px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    padding:10px;
    .progress_box{
      width:100%;
      height:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .progress_one{
        width:100%;
        margin-top:20px;
        display: flex;
        align-items: center;
        flex-direction: row;
        em{
          font-style: normal;
          color:#fff;
          font-size: 14px;
          margin-right: 10px;
        }
        span{
          font-style: normal;
          color:#fff;
          font-size: 14px;
          margin-left: 10px;
        }
        .progress_con{
          flex: 1;
          width:100%;
        }
      }
    }
  }
  .el-progress-bar__outer{
    border-radius: 0 !important;
  }
  .el-progress-bar__inner{
    border-radius: 0 !important;
  }
  .el-progress-bar__outer{
    background-color: #2e3b6f !important;
  }
}


</style>
